export function httpGet(url, headers={}) {
  return httpRequest('GET', url, headers);
}

export function httpPost(url, data, headers={}) {
  return httpRequest('POST', url, headers, data);
}

export function httpRequest(method, url, headers={}, data=null) {

  return new Promise((success, reject) => {

    const request = new XMLHttpRequest();

    request.onreadystatechange = () => {
      if (request.readyState == 4) {
        if (request.status < 400) {
          success(request);
        } else {
          reject(request);
        }
      }
    };

    request.open(method, url);
    addHeaders(request, headers);
    request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    request.setRequestHeader('X-CSRFToken', getCsrfToken());

    if (!(data instanceof String)) {
      data = JSON.stringify(data);
    }

    request.send(data);

  });

}

function csrfCookie() {
  return document.cookie.replace(/(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
}

export function getCsrfToken() {
  // When the CSRF cookie is set, return that, otherwise return the JS var.
  // When an API request is done, the response gives back a CSRF cookie with a
  // new token. Then the JS var is outdated, and the cookie should be used.
  return csrfCookie() || jsVar('csrfToken');
}

export function addHeaders(request, headers) {
  Object.entries(headers).forEach(([key, value]) => {
    request.setRequestHeader(key, value);
  });
}
